import block from "./block.js";
import component from "./component.js"

export default (editor, opts = {}) => {
  editor.DomComponents.addType("title5", component(opts));
  editor.BlockManager.add("title5", block(opts));
};